/**
 * Derive a thumbnail URL from a display URL.
 *
 * Display URLs follow the pattern: .../prefix_display.webp
 * Thumbnails replace "_display" with "_thumb_120" or "_thumb_160".
 *
 * For external URLs (not from R2), returns the URL as-is.
 *
 * @param {string|null} displayUrl - The display-size image URL
 * @param {number} size - Thumbnail size (120 or 160)
 * @returns {string|null}
 */
export const getThumbnailUrl = (displayUrl, size = 120) => {
  if (!displayUrl) return null;
  if (displayUrl.includes("_display.")) {
    return displayUrl.replace("_display.", `_thumb_${size}.`);
  }
  // External URL — return as-is (no thumbnail variant available)
  return displayUrl;
};
